(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('.feature-icon-explainer');
    if (!modal) return;

    modal.classList.remove('open');

    window.addEventListener('click', function(e) {
      const closeBtn = e.target.closest('.feature-icon-explainer__close');
      if (closeBtn) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
        return;
      }

      if (e.target === modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
        return;
      }

      const triggerBtn = e.target.closest('[class*="Understand"], [class*="understand"], .feature-icon-explainer-toggle');
      const clickedText = (e.target.textContent || '').trim();
      const isTextMatch = clickedText.includes('Understand') || clickedText.includes('understand');

      if (triggerBtn || isTextMatch) {
        e.preventDefault();
        e.stopPropagation(); 
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
    }, true);
  });

  } catch(e) { console.error(e); }
})();
})();
